import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import wordmark from '../assets/menu-wordmark.jpg';

function EmailVerifiedView() {
	const navigate = useNavigate();

	const handle_on_click = ()=>{
		navigate('/login');
	}

	function renderMainContent() {
		return (
			<div className="text-center">
				<p className='email-verification-text'>
					Your email address has been verified, thank you. <br/>You can now proceed to login.
				</p>
			</div>
		);
	}

	return (
		<Container fluid className='auth-container'>
		<Row className='auth-row'>
			<Col lg={4} md={6} sm={10} xs={11}>
			<Card className='auth-card'>
				<Card.Body className='auth-card-body'>
				
					<Row>
					<img src={wordmark} className="signin-logo"/>
					<h3 className='auth-title'>Email Verified</h3>
					</Row>
					<Row>
						{renderMainContent()}
					</Row>

					<Row>
						<Button variant="primary" onClick={handle_on_click} >Ok</Button>
					</Row>

				</Card.Body>
			</Card>
			</Col>
		</Row>
		</Container>
	);
}

export default EmailVerifiedView;
